import React from 'react';
import { useTranslation } from 'react-i18next';
import './flowchart.css';

const FlowChart = () => {
  const { t } = useTranslation();
  
  const steps = t('whatToExpect.steps', { returnObjects: true });

  return (
    <section id='whattoexpect' className="flowchart-section">
      <div className="container">
        <h2 className="section-title">{t('whatToExpect.title')}</h2>
        <p className="section-subtitle">{t('whatToExpect.subtitle')}</p>
        
        <div className="flowchart-container">
          {Array.isArray(steps) && steps.map((step, index) => (
            <React.Fragment key={step.id}>
              <div className="flowchart-step">
                <div className="step-number">{index + 1}</div>
                <div className="step-content">
                  <h3>{step.title}</h3>
                  <p>{step.description}</p>
                </div>
              </div>
              
              {index < steps.length - 1 && (
                <div className="flowchart-connector">
                  <div className="connector-line"></div>
                  {/* <div className="connector-arrow">↓</div> */}
                </div>
              )}
            </React.Fragment>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FlowChart;